import { SUPPORTED_LOCALES_OBJ } from '@zep-us/i18n';
import { type GetStaticPropsContext } from 'next';
import { getDefaultStaticProps } from '@/utils';
import { BizLanding } from '../../views/BizLanding';
export default function BizLandingPage() {
  return <BizLanding data-sentry-element="BizLanding" data-sentry-component="BizLandingPage" data-sentry-source-file="index.page.tsx" />;
}
export const getStaticProps = async ({
  locale = SUPPORTED_LOCALES_OBJ.en
}: GetStaticPropsContext) => {
  return getDefaultStaticProps({
    locale,
    namespaces: ['bizLanding']
  });
};